export default "__VITE_ASSET__DvJBstSn__"